var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWebsiteIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9815",
    "data-name": "Group 9815",
    transform: "translate(-12146 17993)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5305",
    "data-name": "Rectangle 5305",
    width: 24,
    height: 24,
    transform: "translate(12146 -17993)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "icons_Q2",
    "data-name": "icons Q2",
    transform: "translate(12147 -17994.363)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3862",
    "data-name": "Path 3862",
    d: "M19.182,6H2.818A.818.818,0,0,0,2,6.818V19.909a.818.818,0,0,0,.818.818h7.364V14.509L8.709,15.982A.818.818,0,0,1,7.441,15.9.859.859,0,0,1,7.6,14.8l2.823-2.823a.777.777,0,0,1,1.145,0L14.4,14.8a.859.859,0,0,1,.164,1.1.818.818,0,0,1-1.268.082l-1.473-1.473v6.218h7.364A.818.818,0,0,0,20,19.909V6.818A.818.818,0,0,0,19.182,6ZM5.273,10.091a.818.818,0,1,1,.818-.818A.818.818,0,0,1,5.273,10.091Zm2.455,0a.818.818,0,1,1,.818-.818A.818.818,0,0,1,7.727,10.091Zm2.455,0A.818.818,0,1,1,11,9.273.818.818,0,0,1,10.182,10.091Z",
    fill: "#a1a1b3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebsiteIcon);
export default __webpack_public_path__ + "static/media/WebsiteIcon.26859e84da04d0d447b5a402d17b78dc.svg";
export { ForwardRef as ReactComponent };